/** Compact toolbar (bold, lists, link, table, …). Strips images from pasted HTML by default. */
import BasicEditor from './BasicEditor';
import { minimalToolbarConfig } from './config';
import type { MinimalHtmlEditorProps } from './types';

function MinimalHtmlEditor(props: MinimalHtmlEditorProps) {
  return <BasicEditor {...props} toolbar={minimalToolbarConfig} />;
}

export default MinimalHtmlEditor;
